import { Injectable } from '@angular/core'
import { ODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IClaimExportConfigView extends IModelBase {
  ClaimExportTypeId: string
  ClaimTypeId: string
  PayerId: string
  JVName: string
}

@Injectable()
export class ClaimExportConfigViewODataService extends ODataService<IClaimExportConfigView> {
  constructor(
    protected http: HttpClient,
    protected config: ODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ClaimExportConfigView'
  }
}
